import { InjectionKey } from 'vue'
import type { TimePickerProps } from './props'

export const DEFAULT_FORMATS_TIME = 'HH:mm:ss'
export const DEFAULT_FORMATS_DATE = 'YYYY-MM-DD'
export const DEFAULT_FORMATS_DATEPICKER = {
  date: DEFAULT_FORMATS_DATE,
  week: 'gggg[w]ww',
  year: 'YYYY',
  month: 'YYYY-MM',
  datetime: `${DEFAULT_FORMATS_DATE} ${DEFAULT_FORMATS_TIME}`,
  monthrange: 'YYYY-MM',
  daterange: DEFAULT_FORMATS_DATE,
  datetimerange: `${DEFAULT_FORMATS_DATE} ${DEFAULT_FORMATS_TIME}`,
}

export interface TimePickerContext {
  props: TimePickerProps
}

export const TimePickerContextKey: InjectionKey<TimePickerContext> = Symbol('TimePickerContextKey')

export interface PopperOptionsContext {}

export const PopperOptionsContextKey: InjectionKey<PopperOptionsContext> = Symbol('PopperOptionsContextKey')
